import * as zod from "zod";

class LocalDate extends Date {

    toJSON(): string {
        const pad = (n: number) => n.toString().padStart(2, '0');

        const ano = this.getFullYear();
        const mes = pad(this.getMonth() + 1);
        const dia = pad(this.getDate());
        const hora = pad(this.getHours());
        const minuto = pad(this.getMinutes());
        const segundo = pad(this.getSeconds());

        return `${ano}-${mes}-${dia}T${hora}:${minuto}:${segundo}`;
    }

}

export const localDateSchema =
    zod.date()
        .transform((date) => new LocalDate(date.getTime()));

export default LocalDate;